import React from 'react';

const CheckBox = (props) => {
  return( 
    <div className="form-group">
      <div className="col-sm-4">
        <label>{props.title}</label>
        {props.badge ? <span className='badge'>必須</span> : ''}
      </div>
      <div className="col-sm-8">
        <input
          className="form-checkbox"
          id = {props.name}
          name={props.name}
          onChange={props.handleChange}
          value={'noHTML'}
          checked={props.selectedOption}
          type="checkbox" />
      </div>
    </div>
  )
}

export default CheckBox;